import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const Bannerp = ({ siteTitle }) => (
  <div className="banner1">
    <div className="container">
      <div className="row">
        <div className="main-text">Participation</div>
      </div>
    </div>
  </div>
)

export default Bannerp
